import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { MtMailSettings } from "server/models"
import { StateType } from "client/utils"
import {
    StoreType,
    MailSettingsValidation,
    SaveMailSetting,
    setMailSettingEdit,
    setMailSettingReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    FormGroup,
    Input,
    Feedback,
    SpinnerIcon,
} from "client/components"


export const EditSetting = () => {
    const setting = useSelector((state: StoreType) => state.mail.settingEdit)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [value, setValue] = useState("")
    const [validation, setValidation] = useState<MailSettingsValidation>(null)

    const [saveState, setSaveState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        setValue(setting ? setting.value : "")
        setValidation(null)
    }, [setting])

    const onCancel = () => {
        dispatch(setMailSettingEdit(null))
    }

    const onSave = (mode: number) => {
        if (mode === 1) setSaveState(PENDING)
        if (mode === 2) setApplyState(PENDING)

        const newSettingData: MtMailSettings = {
            ...setting,
            value,
        }

        SaveMailSetting(newSettingData, lang)
        .then((res) => {
            setValidation(res.validation)
            setSaveState(IDLE)
            setApplyState(IDLE)
            if (res.validation) return

            dispatch(setMailSettingReloadList(false))
            setTimeout(() => {
                dispatch(setMailSettingReloadList(true))
            }, 0)

            if (mode === 1) onCancel()
            if (mode === 2) {
                dispatch(setMailSettingEdit(newSettingData))
            }
        })
    }

    return (
        <ConfirmWrapper show={setting !== null} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{setting ? setting.name : ""}</ConfirmTitle>
                <ConfirmDescription>
                    <FormGroup>
                        <Input type="text" value={value} onChange={(e) => setValue(e.target.value)} />
                        <Feedback>{validation && validation.value}</Feedback>
                    </FormGroup>
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row onClick={() => onSave(1)}>
                        {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                    </Button>
                    <Button variant="success" row onClick={() => onSave(2)}>
                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                    </Button>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default EditSetting
